import { loadMessages } from "@repo/i18n/loader"
import { mergeMessages } from "@repo/i18n/merge"
import { getRequestConfig } from "next-intl/server"

export const locales = ["en", "th", "id", "es", "fr", "pt", "ru", "vn", "ko"] as const
export type Locale = (typeof locales)[number]
export const defaultLocale: Locale = "en"

// 向服务端组件传递信息
export default getRequestConfig(async ({ requestLocale }) => {
	const requested = await requestLocale
	const activeLocale: Locale =
		requested && (locales as readonly string[]).includes(requested) ? (requested as Locale) : defaultLocale

	// 使用 loader 动态加载共享翻译
	const sharedMessages = loadMessages(activeLocale)
	let localMessages: Record<string, unknown>

	try {
		localMessages = (await import(`../messages/${activeLocale}.json`)).default
	} catch {
		localMessages = (await import("../messages/en.json")).default
	}

	return {
		locale: activeLocale,
		// 合并翻译，本地翻译会覆盖共享翻译中的同名键
		messages: mergeMessages(sharedMessages, localMessages),
	}
})
